import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { buildErrorMessage } from 'utils'
import { UseMutationOptions } from 'react-query/types/react/types'
import { sendToApi } from 'api/client'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

export type Data = {
  bid: string
}

export interface Variables {
  brandKitId: number
  channel_type: 'social' | 'seo' | 'email'
}

export type Options = Omit<UseMutationOptions<Data, unknown, Variables>, 'mutationKey' | 'mutationFn'>

export const createStrategicRecommendations = async ({
  workspaceId,
  brandKitId,
  channel_type,
}: Variables & { workspaceId: number }) => {
  const response = await sendToApi<Data>(`/w/${workspaceId}/brand_kits/${brandKitId}/strategic_recommendations`, {
    method: 'POST',
    body: {
      channel_type,
    },
  })

  if (response.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(
      buildErrorMessage(response.data.errors) ||
        'An error occurred! Our team has been notified and we are looking into it.',
    )
  }
  return response.data
}

export const useCreateStrategicRecommendations = (options?: Options) => {
  const workspaceId = useCurrentWorkspaceId()

  return useMutation<Data, unknown, Variables>(
    'createStrategicRecommendations',
    async (variables) => {
      return createStrategicRecommendations({ workspaceId, ...variables })
    },
    options,
  )
}
